export default {
    en: {
        YES: 'Yes',
        NO: 'No',
        LOGIN: 'Login',
        LOGOUT: 'Logout',
        JOIN_REQUEST: 'Join Request',
        USERNAME_FIELD: 'User',
        PASSWORD_FIELD: 'Password',
        LOGOUT_CONFIRM_MESSAGE: 'Are you sure you want to proceed?',
        CONFIRMATION_HEADER: 'Confirmation',
        NO_RESPONSE_FROM_SERVER: 'No response from server',
        UNKNOW_ERROR: 'Unknow error',
        SESSION_EXPIRED: 'Session expired',
        WE_MENU: 'We',
        MECHANISM_MENU: 'Mechanism',
        SPONSORS_MENU: 'Sponsors',
        SUPPORTERS_MENU: 'Supporters',
        PARTNERS_MENU: 'Partners',
        SERVICES_MENU: 'Services',
        PROFILE_MENU: 'Profile',
        NOTIFICATIONS: 'Notifications',
        MESSAGES_MENU: 'Messages'
    },
    ar: {
        YES: 'نعم',
        NO: 'لا',
        LOGIN: 'دخول',
        LOGOUT: 'خروج',
        JOIN_REQUEST: 'طلب إنضمام',
        SEND_REQUEST: 'إرسال الطلب',
        USERNAME_FIELD: 'إسم المستخدم',
        PASSWORD_FIELD: 'كلمة السر',
        PASSWORD_FIELD_CONFIRMATION: 'تأكيد كلمة السر',
        PASSWORD_NOT_MATCHING: 'كلمة السر غير متطابقة',
        LOGOUT_CONFIRM_MESSAGE: 'هل تؤكد الخروج ؟',
        DELETE_ACCOUNT_CONFIRM_MESSAGE: 'هل تريد فعلاً إلغاء حسابك ؟ العملية غير قابلة للإلغاء لاحقاً !',
        CONFIRMATION_HEADER: 'تأكيد',
        CONFIRMATION: 'تأكيد',
        NO_RESPONSE_FROM_SERVER: 'لا يوجد رد من السرفر',
        UNKNOW_ERROR: 'خطأ غير معروف',
        BAD_CREDENTIALS: 'معلومات دخول غير صحيحة',
        DELETE_ACCOUNT: 'حذف الحساب',
        USER_DELETED_SUCCESSFULLY: 'تم حذف المستخدم بنجاح',
        INVALID_EMAIL: 'بريد إلكتروني غير صحيح',
        OPERATIONS: 'عملياتي',
        USER_JOIN_REQUESTS: 'طلبات الإنضمام',
        SESSION_EXPIRED: 'انتهت صلاحيةالجلسة ',
        HOME: 'الرئيسية',
        COVER_CORRECTION: 'تصحيح الأغلفة',
        PROFILE_MENU: 'البيانات الشخصية',
        NOTIFICATIONS: 'إشعارات',
        MESSAGES_MENU: 'رسائل',
        FIRST_NAME: 'الإسم الشخصي',
        LAST_NAME: 'الإسم العائلي',
        EMAIL: 'البريد الإلكتروني',
        USER: 'المستخدم',
        USER_JOIN_REQUEST_DATE: 'تاريخ طلب الإنضمام',
        BOOKS_FILE_UPLOAD_DATE: 'تاريخ رفع الملف',
        CHANGE_PASSWORD: 'تغيير كلمة المرور',
        FORGOT_PASSWORD: 'نسيت كلمة السر',
        SEND: 'إرسال',
        ENTER_YOUR_EMAIL_ADDRESS: 'أدخل بريدك الإلكتروني',
        REQUEST: 'طلبات',
        BORROW: 'إستعارة',
        EXCHANGE: 'تبادل',
        GIFT: 'إهداء',
        SEARCH: 'بحث',
        BOOK_TITLE: 'عنوان الكتاب',
        BOOK_AUTHOR: 'المؤلف',
        PUBLISHER: 'دار النشر',
        PUBLISH_YEAR: 'سنة النشر',
        BOOK_CATEGORY: 'تصنيف الكتاب',
        CHANGE_PHOTO: 'تغيير صورة الحساب',
        SELECT_PHOTO: 'إختيار الصورة',
        CHANGE_PHOTO_LABEL: 'تغيير الصورة',
        UPLOAD: 'رفع',
        CHOOSE: 'إختيار',
        CANCEL: 'إلغاء',
        PARTNER: 'الشريك',
        GIFT_MESSAGE: 'نص الإهداء',
        BORROWING: 'إستعارة',
        BORROWING_MESSAGE: 'نص الإستعارة',
        CREATE_GIFT_BUTTON: 'إنشاء الإهداء',
        CREATE_BORROWING_BUTTON: 'إنشاء الإستعارة',
        INTERNAL_SERVER_ERROR: 'حصل خطأ أثناء إتمام العملية',
        USER_INFO: 'معلومات الشريك',
        OPERATION_INFO: 'معلومات العملية',
        BOOKS_LIST: 'قائمة الكتب',
        ACCEPT_BTN: 'قبول',
        REJECT_BTN: 'رفض',
        CONFIRM_OPERATION: 'هل تؤكد تسليم الكتب ؟',
        REJECT_OPERATION: 'هل تريد رفض العملية ؟',
        ACCEPT_OPERATION: 'هل تريد قبول العملية ؟',
        CANCEL_OPERATION: 'هل تريد إلغاءالعملية ؟',
        CHAT: 'محادثة',
        UNAUTHORIZED: 'دخول غير مصرح به',
        ACCESS_DENIED: 'ليس لديك الصلاحية لإتمام العملية',
        USER_NOT_LOGGED: 'المستخدم غير مسجّل',
        VALIDATION_ERROR: 'المعلومات المدرجة خاطئة أو غير كاملة',
        EMPTY: 'لا توجد عمليات حاليا',
        OWNER: 'الشريك',
        CLEAR: 'مسح',
        MY_BOOKS: 'مكتبتي',
        OTHERS_BOOKS: 'كتب الشركاء',
        OTHER_BOOKS: 'كتب الشريك',
        EXCHANGE_MESSAGE: 'نص التبادل',
        CREATE_EXCHANGE_BUTTON: 'إنشاء التبادل',
        MY_CHOSEN_BOOKS: 'كتبي المختارة',
        OTHER_CHOSEN_BOOKS: 'كتب الشريك المختارة',
        EXCHANGE_EXPIRATION_DATE: 'تاريخ انتهاء التبادل',
        BORROWING_EXPIRATION_DATE: 'تاريخ انتهاء الإستعارة',
        OPERATION_EXPIRATION_DATE: 'تاريخ انتهاء العملية',
        CONFIRM_RETRIEVAL: 'هل تؤكد إستعادة الكتب ؟',
        SEND_EMAIL: 'إرسال بريد إلكتروني',
        PASSWORD_CHANGE: 'إضغط زر الإرسال لكي يرسل لك النظام كود تحقق لتغيير كلمة السر',
        PASSWORD_RECOVERY_INPUT: 'المرجو إدخال الكود الذي تم إرساله إلى بريدك الإلكتروني',
        CHECK_CODE: 'كود التحقق',
        PASSWORD_CONFIRM_FIELD: 'تأكيد كلمة السر',
        DRAG_FOTO_MESSAGE: 'قم بسحب الصورة إلى هذا المربع لرفعها',
        DRAG_FILE_MESSAGE: 'إلى هذا المربع لرفعه CSV قم بسحب ملف ',
        CORRECT: 'تصحيح',
        UPLOAD_BOOKS: 'إضافة كتب',
        TAKE_FOTO: 'التقاط صورة',
        CREATED: 'قيد المراجعة',
        APPROVED_BY_ADMIN: 'عملية جارية',
        REJECTED_BY_ADMIN: 'عملية مرفوضة',
        REJECTED: 'مرفوضة',
        WAITING_DEAL_CONFIRMATION: 'جاري التسليم',
        CANCELED: 'ملغاة',
        DEAL_CONFIRMED_BY_SENDER: 'جاري التأكيد',
        DEAL_CONFIRMED_BY_RECEIVER: 'جاري التأكيد',
        IN_PROGRESS: 'جارية',
        RETRIEVED_BY_SENDER: 'جاري الإستعادة',
        RETRIEVED_BY_RECEIVER: 'جاري الإستعادة',
        COMPLETED: 'عملية تامة',
        RECENT_OPERATIONS: 'آخر عملياتي ',
        SOON_ENDING_OPERATIONS: 'عمليات وشيكة الإنتهاء',
        GLOBAL_STATS: 'إحصائيات',
        GIFTS_OPERATIONS: 'عمليات الإهداء',
        BORROWING_OPERATIONS: 'عمليات الإستعارة',
        EXCHANGE_OPERATIONS: 'عمليات التبادل',
        OWNER_COUNT: 'مجموع الشركاء',
        BOOKS_COUNT: 'مجموع الكتب',
        SCORE: 'عدد النقاط',
        ACCEPT_CONFIRMED: 'تم قبول العملية',
        REJECT_CONFIRMED: 'تم رفض العملية',
        CANCEL_CONFIRMED: 'تم إلغاء العملية',
        CONFIRMATION_DONE: 'تم تأكيد العملية',
        RETRIEVAL_CONFIRMED: 'تم تأكيد الإسترجاع',
        USER_EVALUATED: 'تم تقييم الشريك',
        EVALUATION_POINTS: 'تقييم الشركاء',
        CONFIRM_USER_EVALUATION: 'هل تود مكافأة الشريك ب 25 نقطة ؟',
        NON_EXPIRING_OPERATION: 'عملية نهائية (بدون إسترجاع كتب)',
        STATUS: 'حالة العملية',
        TYPE: 'نوع العملية',
        CREATION_DATE: 'تاريخ الإنشاء',
        EXPIRATION_DATE: 'تاريخ الصلاحية',
        SERVER_SUDDEN_DEATH: 'السرفر متوقف حالياً',
        GIFT_CREATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بإنشاء عملية إهداء لك ',
        BORROWING_CREATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بإنشاء عملية إستعارة منك ',
        EXCHANGE_CREATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بإنشاء عملية تبادل معك ',
        ADMIN_GIFT_CREATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بإنشاء عملية إهداء',
        ADMIN_BORROWING_CREATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بإنشاء عملية إستعارة',
        ADMIN_EXCHANGE_CREATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بإنشاء عملية تبادل',
        ADMIN_REJECTED_OPERATION_NOTIFICATION_TEMPLATE: 'المشرف %s قام برفض إتمام العميلة ',
        ADMIN_APPROVED_OPERATION_NOTIFICATION_TEMPLATE: 'المشرف %s وافق على إتمام العملية',
        USER_REJECTED_OPERATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام برفض إتمام العميلة',
        USER_APPROVED_OPERATION_NOTIFICATION_TEMPLATE: 'الشريك %s وافق على إتمام العملية',
        USER_CANCELED_OPERATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بالغاء العملية',
        USER_CONFIRMED_OPERATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بتأكيد تسليم الكتب',
        USER_CONFIRMED_RETRIEVAL_NOTIFICATION_TEMPLATE: 'الشريك %s قام بتأكيد إعادة الكتب',
        USER_FLAGGED_OPERATION_NOTIFICATION_TEMPLATE: 'الشريك %s قام بالتبليغ عن مشكلة',
        BOOK_RETURN_REMINDER: 'تذكير بإرجاع الكتب',
        FREE_CHATS: 'محادثات حرة',
        OPEARTIONS_CHATS: 'مرتبطة بعملية',
        NEW_CHAT_THREAD: 'محادثة جديدة',
        REGISTER_INCIDENCE: 'تبليغ',
        REGISTER_INCIDENCE_MESSAGE: 'المرجو كتابة تفاصيل المشكلة لمراجعتها من طرف الإدارة',
        INCIDENCE_REGISTERED: 'تم التبليغ',
        WILL: 'وصية',
        SAVE_WILL: 'حفظ الوصية',
        WILL_SAVED: 'تم حفظ الوصية',
        LAST_UPDATE: 'آخر تحديث',
        BOOK_DETAIL: 'معلومات الكتاب',
        PUBLISHING_HOUSE: 'دار النشر',
        PUBLISHING_YEAR: 'سنة النشر',
        BOOKS: 'كتب',
        BOOK_OPERATIONS: 'عمليات الكتاب',
        REWARDS: 'مكافآت',
        REWARD: 'مكافأة',
        USER_REWARDED: 'تم إشعار الشريك بمكافأته',
        REWARD_POINTS: 'عدد نقاط المكافأة',
        REWARD_COMMENT: 'تعليق عن المكافأة',
        POINT: 'نقطة',
        LANGUAGE: 'اللغة',
        PAGES: 'عدد الصفحات',
        CANT_SEND_MULTIPLE_FILE: 'لا يمكن إرسال ملفات متعددة في طلب واحد',
        UPLOADED_FILE_SHOULD_BE_CSV: 'CSV الملف المختار يجب أن يكون',
        OWNER_BOOKS_COUNT: 'عدد كتب الشريك',
        REWARDABLE_POINTS: 'رصيد المكافآت',
        MYBOOKS: 'مكتبتي',
        NOLASTOPERATION: ' ستظهر آخر عمليات الإهداء أوالاستعارة أوالتبادل التي قمت بها خلال الأسبوع الجاري',
        NOSOONPERATION: 'ستظهر عمليات الاستعارة والتبادل المحددة بتاريخ فور قيامك بها مع أي شريك',
        EMPTYMSG: 'لا توجد رسائل حاليا', 
        DELETED_ACCOUNT: 'شريك محذوف'
    }
}